import { writable } from 'svelte/store';

const isServer = typeof window === 'undefined';

function createPersistentStore(key, startValue) {
  const { subscribe, set, update } = writable(startValue);

  if (!isServer) {
    const savedValue = localStorage.getItem(key);
    if (savedValue) {
      try {
        set(JSON.parse(savedValue));
      } catch (error) {
        console.error(`Error parsing local storage for key "${key}":`, error);
        localStorage.removeItem(key);
      }
    }
  }

  return {
    subscribe,
    set: (value) => {
      set(value);
      if (!isServer) {
        localStorage.setItem(key, JSON.stringify(value));
      }
    },
    // Wrap the original update function to add persistence
    update: (updater) => {
      update(currentValue => {
        const nextValue = updater(currentValue);
        if (!isServer) {
          localStorage.setItem(key, JSON.stringify(nextValue));
        }
        return nextValue;
      });
    }
  };
}

// User-related stores
export const user = createPersistentStore('user', null);
export const userTier = createPersistentStore('userTier', 'basic');

// Search-related stores
export const searchQuery = writable('');
export const currentSearchThreadId = writable(null);
export const results = writable([]);
export const queryHeader = writable('');
export const overallSummary = writable('');
export const isLoadingResults = writable(false);
export const isLoadingAnswer = writable(false);
export const resultsVisible = writable(true);
export const isLoadingQueryHeader = writable(false);

// History-related store
// Make history non-persistent, rely on DB fetch via AuthService
export const history = writable([]);
export const isHistoryLoading = writable(true); // Added loading state


// Follow-up search stores
export const followUpQueries = createPersistentStore('followUpQueries', []);
export const followUpResults = createPersistentStore('followUpResults', []);
export const followUpAnswer = createPersistentStore('followUpAnswer', []);
export const followUpResultsVisible = createPersistentStore('followUpResultsVisible', []);
export const followUpIsLoadingResults = writable([]);
export const followUpIsLoadingAnswer = writable([]);
export const followUpIsLoadingQueryHeader = writable([]);

// Additional stores used in App.svelte
export const followUpSearches = writable([]);
export const followUpQuery = writable('');

// Helper functions
export function setUser(userData) {
  user.set(userData);
}

export function clearUser() {
  user.set(null);
}

export function updateResults(newResults) {
  results.set(newResults);
}